import React from 'react';
import { useTranslation } from 'react-i18next';

import { TaskPriority } from '@/services/ws-funnel/src/main/resources/rest-api';
import { Marker } from '@/js/libs/ui/src/V2';

import type { ColumnProps } from '../../types';

export const PriorityCell: React.FC<ColumnProps> = React.memo(function PriorityCell({ item }) {
  const [t] = useTranslation(['backend', 'serviceDashboard']);

  if (!item.priority) {
    return null;
  }

  return (
    <Marker
      title={t(item.priority, { ns: 'serviceDashboard' })}
      positive={item.priority === TaskPriority.LOW}
      warning={item.priority === TaskPriority.MEDIUM}
      negative={item.priority === TaskPriority.HIGH}
    />
  );
});
